import { Breadcrumbs, Chip, Link, Stack } from "@mui/material";
import HerbImage from "../../assets/doors/8_ecbt.jpeg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { SiteRoutes } from "../../PageRouter";

export const Door8 = () => {
  const ingredients = [
    "Chili",
    "Knoblauch",
    "Koriander",
    "Kumin",
    "Paprika",
    "Meersalz",
  ];

  const doorNr = 8;

  const shortDecription =
    "Harissa - die Würze des Orients. Harissa - ein Wort für die Sinne. \nFür schärfe-empfindliche: Vorsicht scharf";

  const herbName = "Harissa";

  const recepieExample = (
    <div>
      <div>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.hellofresh.de/recipes/wurziges-ofen-harissa-hahnchen-5d2ec8527ac6d4000d429dbb"
        >
          Würziges Ofen-Harissa-Hähnchen
        </Link>
      </div>
      <div>
        Außerdem ideal zum Verfeinern von Couscous und Schmortöpfen mit Fleisch
        und Gemüse
      </div>
    </div>
  );

  const breadcrumb = (
    <Breadcrumbs maxItems={4} separator={<NavigateNextIcon fontSize="small" />}>
      <Link
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        color="inherit"
        href="/"
      >
        Start
      </Link>
      {SiteRoutes.map((route) => {
        if (route.doorNumber && route.doorNumber <= doorNr) {
          return (
            <Link
              key={route.path}
              underline="hover"
              color="inherit"
              href={route.path}
            >
              Tag {route.doorNumber}
            </Link>
          );
        } else {
          return undefined;
        }
      })}
    </Breadcrumbs>
  );

  return (
    <>
      <img src={HerbImage} className="herb_img" alt="herb" />
      {breadcrumb}
      <h1 className="herb_name">{herbName}</h1>
      <i>{shortDecription}</i>
      <h3 className="content">Inhalt</h3>
      <div>
        <Stack
          spacing={1}
          direction="row"
          useFlexGap
          flexWrap="wrap"
          justifyContent="center"
        >
          {ingredients.map((ingredient, i) => {
            return (
              <Chip
                key={i}
                style={{ flexGrow: 1 }}
                label={ingredient}
                variant={i % 2 === 0 ? "filled" : "outlined"}
              />
            );
          })}
        </Stack>
      </div>
      <h3>Rezeptidee</h3>
      {recepieExample}
    </>
  );
};
